import { render } from "./AnalyticsTab.vue?vue&type=template&id=f60ada18&scoped=true"
import script from "./AnalyticsTab.vue?vue&type=script&lang=js"
export * from "./AnalyticsTab.vue?vue&type=script&lang=js"

import "./AnalyticsTab.vue?vue&type=style&index=0&id=f60ada18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60ada18"]])

export default __exports__